/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Input_Title_LabelInputs */

const en_jobs_input_title_label = /** @type {(inputs: Jobs_Input_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Title`)
};

const de_jobs_input_title_label = /** @type {(inputs: Jobs_Input_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stellentitel`)
};

const fr_jobs_input_title_label = /** @type {(inputs: Jobs_Input_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titre du poste`)
};

const es_jobs_input_title_label = /** @type {(inputs: Jobs_Input_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título del puesto`)
};

const it_jobs_input_title_label = /** @type {(inputs: Jobs_Input_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titolo del lavoro`)
};

const nl_jobs_input_title_label = /** @type {(inputs: Jobs_Input_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Functietitel`)
};

const pl_jobs_input_title_label = /** @type {(inputs: Jobs_Input_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nazwa stanowiska`)
};

const fi_jobs_input_title_label = /** @type {(inputs: Jobs_Input_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tehtävänimike`)
};

const da_jobs_input_title_label = /** @type {(inputs: Jobs_Input_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobtitel`)
};

const sv_jobs_input_title_label = /** @type {(inputs: Jobs_Input_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobbtitel`)
};

/**
* | output |
* | --- |
* | "Job Title" |
*
* @param {Jobs_Input_Title_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_input_title_label = /** @type {((inputs?: Jobs_Input_Title_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Input_Title_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_input_title_label(inputs)
	if (locale === "fr") return fr_jobs_input_title_label(inputs)
	if (locale === "es") return es_jobs_input_title_label(inputs)
	if (locale === "it") return it_jobs_input_title_label(inputs)
	if (locale === "nl") return nl_jobs_input_title_label(inputs)
	if (locale === "pl") return pl_jobs_input_title_label(inputs)
	if (locale === "fi") return fi_jobs_input_title_label(inputs)
	if (locale === "da") return da_jobs_input_title_label(inputs)
	if (locale === "sv") return sv_jobs_input_title_label(inputs)
	return en_jobs_input_title_label(inputs)
});